import {defineStore, storeToRefs} from "pinia";
import {useTimestamp} from "@vueuse/core";
import {computed} from "vue";
import {useDebugStore} from "@/core/store/debug";
import toInt from "@/core/util/toInt";
import dayjs from "dayjs";

export const useTime = defineStore("timers", () => {

    const debugStore = useDebugStore()

    const {debugOptions} = storeToRefs(debugStore)

    const timeOffset = computed(() => {
        return toInt(debugOptions.value.timeOffset, 0)
    })

    const getCurrentTimestamp = () => {
        return Date.now() + timeOffset.value
    }

    const getCurrentUnixTimestamp = () => {
        return Math.round(getCurrentTimestamp() / 1000)
    }

    const timestampMinute = useTimestamp({controls: false, interval: 10000, immediate: true})
    const timestampIntervalMinute = computed(() => timestampMinute.value + timeOffset.value)
    const timestampUnixIntervalMinute = computed(() => Math.round(timestampIntervalMinute.value / 1000))

    const timestampIntervalMinuteFormatted = computed(() => {
        return dayjs(timestampIntervalMinute.value).format('DD.MM.YYYY HH:mm')
    })

    const timestampIntervalMinuteDate = computed(() => {
        return dayjs(timestampIntervalMinute.value).toDate()
    })

    return {
        getCurrentUnixTimestamp,
        timestampIntervalMinute,
        timestampIntervalMinuteFormatted,
        timestampUnixIntervalMinute,
        timestampIntervalMinuteDate
    }
})
